import { render } from "./SurveyDetailTable.vue?vue&type=template&id=7281aff4"
import script from "./SurveyDetailTable.vue?vue&type=script&lang=ts"
export * from "./SurveyDetailTable.vue?vue&type=script&lang=ts"
script.render = render

export default script